import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';

import SelectOption from '../../components/Inputs/Select/Select';
import Text from '../../components/Inputs/Text/Text';
import Radio from '../../components/Inputs/Radio/Radio';

import EnumService from '../../services/Enum';

import { 
    isBlank, 
    isBlankHelperText 
} from '../../helper/ValidationHelper';

export class NecessidadeEspecial extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            possuiNecessidadeEspecial: null,
            necessidadeEspecial: '',
            descricaoOutrasDeficiencias: '',
            errors: {
                possuiNecessidadeEspecial: false,
                necessidadeEspecial: false,
                descricaoOutrasDeficiencias: false,
            },
            helpers: {
                possuiNecessidadeEspecial: null,
                necessidadeEspecial: null,
                descricaoOutrasDeficiencias: null,
            },
            disabled: {
                possuiNecessidadeEspecial: false,
                necessidadeEspecial: false,
                descricaoOutrasDeficiencias: false,
            },
            optionsNecessidadeEspecial: [],
        }
        this.isValid = this.isValid.bind(this);
    }

    // INPUTS
    handleChange = e => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value,
            errors: {...this.state.errors, [e.target.name]: false },
            helpers: {...this.state.helpers, [e.target.name]: null },
            disabled: {...this.state.disabled }
        });
    }

    handleChangeRadio = e => {
        let value = e.target.value;

        if (value === "true") value = true;
        else if (value === "false") value = false;

        this.setState({
            ...this.state,
            [e.target.name]: value,
            necessidadeEspecial: value ? this.state.necessidadeEspecial : '',
            descricaoOutrasDeficiencias: value ? this.state.descricaoOutrasDeficiencias : '',
            errors: {
                possuiNecessidadeEspecial: false,
                necessidadeEspecial: false,
                descricaoOutrasDeficiencias: false,
            },
            helpers: {
                possuiNecessidadeEspecial: null,
                necessidadeEspecial: null,
                descricaoOutrasDeficiencias: null,
            },
        });
    }

    // VALIDAÇÕES
    isValid = () => {
        const possuiNecessidadeEspecialBlank = isBlank(this.state.possuiNecessidadeEspecial)
        const necessidadeEspecialBlank = this.state.possuiNecessidadeEspecial && isBlank(this.state.necessidadeEspecial);
        const descricaoOutrasDeficienciasBlank = this.state.necessidadeEspecial === "OUTRAS" && isBlank(this.state.descricaoOutrasDeficiencias);

        if (possuiNecessidadeEspecialBlank || necessidadeEspecialBlank || descricaoOutrasDeficienciasBlank) {
            this.setState({
                ...this.state,
                errors: {
                    possuiNecessidadeEspecial: possuiNecessidadeEspecialBlank,
                    necessidadeEspecial: necessidadeEspecialBlank,
                    descricaoOutrasDeficiencias: descricaoOutrasDeficienciasBlank,
                },
                helpers: {
                    possuiNecessidadeEspecial: possuiNecessidadeEspecialBlank ? isBlankHelperText() : null,
                    necessidadeEspecial: necessidadeEspecialBlank ? isBlankHelperText() : null,
                    descricaoOutrasDeficiencias: descricaoOutrasDeficienciasBlank ? isBlankHelperText() : null,
                },
                disabled: {...this.state.disabled }
            });
            return false;
        }
        return true;
    }

    async componentDidMount() {
        const necessidadesEspeciais = await EnumService.listarNecessidadesEspeciais().then(res => res.data);
        this.setState({ ...this.state, optionsNecessidadeEspecial: [...necessidadesEspeciais] });
    }

    render () {
        return (
            <>
                <Grid container spacing={3}>
                    <Grid item sm={12} lg={3} style={{ marginTop: 6 }}>
                        <Radio
                            row
                            name="possuiNecessidadeEspecial"
                            options={[{ value: false, label: "Não" }, { value: true, label: "Sim" }]}
                            value={this.state.possuiNecessidadeEspecial}
                            helperText={this.state.helpers.possuiNecessidadeEspecial}
                            error={this.state.errors.possuiNecessidadeEspecial}
                            onChange={this.handleChangeRadio}
                            disabled={this.props.disabled}
                        />
                    </Grid>
                </Grid>

                { this.state.possuiNecessidadeEspecial &&
                    <Grid container spacing={3}>
                        <Grid item sm={12} lg={4}>
                            <SelectOption 
                                required
                                label=" "
                                name='necessidadeEspecial'
                                value={this.state.necessidadeEspecial}
                                error={this.state.errors.necessidadeEspecial}
                                onChange={(e) => this.handleChange(e)}
                                options={this.state.optionsNecessidadeEspecial}
                                hiddenblank="true"
                                helperText={this.state.helpers.necessidadeEspecial}
                                disabled={this.state.disabled.necessidadeEspecial || this.props.disabled}
                            />
                        </Grid>
                    </Grid>
                }

                { (this.state.possuiNecessidadeEspecial && this.state.necessidadeEspecial === 'OUTRAS') && 
                    <>
                        <Grid container spacing={3}>
                            <Grid item sm={12} lg={9}>
                                <Text
                                    required
                                    name="descricaoOutrasDeficiencias"
                                    label="Descrição para Deficiência"
                                    value={this.state.descricaoOutrasDeficiencias}
                                    error={this.state.errors.descricaoOutrasDeficiencias}
                                    onChange={this.handleChange}
                                    helperText={this.state.helpers.descricaoOutrasDeficiencias}
                                    disabled={this.state.disabled.descricaoOutrasDeficiencias || this.props.disabled}
                                />
                            </Grid>
                        </Grid>
                    </> 
                }
            </>
        )
    }
}

export default NecessidadeEspecial;